<div>
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <span>Work Centers</span>
      <button mat-button (click)="onRefresh()">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
      <button mat-button (click)="onAdd()">
        <mat-icon aria-hidden="false" aria-label="Add Work Center">add</mat-icon>
        Add Work Center
      </button>
      <span class="toolbar-spacer"></span>
      <mat-form-field color="accent">
        <input
          matInput
          placeholder="Search work centers..."
          [value]="filter"
          (input)="onFilter($event.target['value'])"
        />
      </mat-form-field>
      <button mat-icon-button aria-label="Clear" *ngIf="filter" (click)="onFilter('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <ng-container *ngIf="loading; else loaded">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading Work Centers...</p>
    </div>
  </ng-container>
  <ng-template #loaded>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort width="100%">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let item">{{ item.id }}</td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let item">{{ item.name }}</td>
      </ng-container>
      <ng-container matColumnDef="number">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Number</th>
        <td mat-cell *matCellDef="let item">{{ item.number }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button mat-flat-button color="accent" (click)="openDialog(item)">Edit</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>
  </ng-template>
</div>
